import { createFileRoute } from '@tanstack/react-router';

import { ROLES } from '~/constants';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';

export const Route = createFileRoute('/_app/evaluation')({
    beforeLoad: ({ location }) => {
        authoriseUser(Object.values(ROLES), location);
        const content = 'ROUTE_TITLE.EVALUATION';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
});
